import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { RichTreeViewPro } from '@mui/x-tree-view-pro/RichTreeViewPro';
import Rating from '@mui/material/Rating';
import Checkbox from '@mui/material/Checkbox';
import CheckboxIcon from '../../icons/CheckboxIcon';
import CheckboxIconChecked from '../../icons/CheckboxIconChecked';
import { useTreeItem } from '@mui/x-tree-view/useTreeItem';
import {
  TreeItemContent,
  TreeItemIconContainer,
  TreeItemGroupTransition,
  TreeItemLabel,
  TreeItemRoot,
} from '@mui/x-tree-view/TreeItem';
import { useTreeItemModel, useTreeViewApiRef } from '@mui/x-tree-view/hooks';
import { Autocomplete, Box, IconButton, MenuItem, Popper, TextField } from '@mui/material';
import { TreeItemIcon } from '@mui/x-tree-view/TreeItemIcon';
import { TreeItemProvider } from '@mui/x-tree-view/TreeItemProvider';
import { TreeItemDragAndDropOverlay } from '@mui/x-tree-view/TreeItemDragAndDropOverlay';
import {
  updateMatrixCategory,
  getMatrixGategories,
  moveMatrixCategory,
  moveCompetence,
  addMatrixCategory,
  deleteMatrixCategory,
  updateCompetence,
  blockMatrixCategory,
  blockCompetence,
  addCompetence,
  deleteCompetence,
  getDepartmentsList,
  getCompetenceByUser,
  getGradesList,
  getCompetencyGrades,
  addCompetenceRateByUser,
} from '../../../../api';
import { TreeItemLabelInput } from '@mui/x-tree-view';
import PlusIcon from '../../icons/PlusIcon';
import ReorderIcon from '../../icons/ReorderIcon';
import BlockColoredIcon from '../../icons/BlockColoredIcon';
import DeleteColoredIcon from '../../icons/DeleteColoredIcon';
import ChevronIcon from '../../icons/ChevronIcon';
import ArrowDownIcon from '../../icons/ArrowDownIcon';
import ArrowUpIcon from '../../icons/ArrowUpIcon';
import FolderIcon from '../../icons/FolderIcon';
import AddColorPlusIcon from '../../icons/addColorPlusIcon';
import WarningModal from '../../components/WarningModal';
import { useTranslation } from '../../../../utils/getLocalString';
import { useParams } from 'react-router-dom';
import { styled } from '@mui/material/styles';
const StyledDragOverlay = styled(TreeItemDragAndDropOverlay)(({ theme }) => ({
  '&.MuiTreeItemDragAndDropOverlay-root': {
    '&[data-position="insert"]::before': {
      backgroundColor: '#1976d2',
      height: '2px',
    },
    '&[data-position="nest"]': {
      outline: '2px solid #4CAF50',
    },
  },
}));
const StyledDepartmentsContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: '16px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
}));
// Original class: fieldAutocomplete
const StyledFieldAutocomplete = styled(Autocomplete)(({ theme }) => ({
  '& .MuiInputBase-root.MuiOutlinedInput-root': {
    background: '#fff',
    padding: '8px 65px 8px 16px',
    lineHeight: '20px',
    height: 'auto',
    '& .MuiAutocomplete-endAdornment': {
      '& .MuiButtonBase-root.MuiIconButton-root.MuiAutocomplete-clearIndicator': {
        '& .MuiSvgIcon-root': {
          width: '20px',
          height: '20px',
        },
      },
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
        position: 'static',
      },
    },
    '& .MuiAutocomplete-input': {
      fontSize: '12px',
      lineHeight: '20px',
      //color: '#212346',
      padding: '0',
      height: 'auto',
    },
    '&.Mui-disabled': {
      '& .MuiAutocomplete-input': {
        '&::placeholder': {
          color: '#E4E4EF',
        },
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#E4E4EF',
      },
      '& .MuiAutocomplete-endAdornment': {
        '& .MuiSvgIcon-root path': {
          fill: '#E4E4EF',
        },
      },
    },
    '&:hover': {
      '&.MuiInputBase-root': {
        '&.MuiOutlinedInput-root': {
          backgroundColor: '#fff',
        },
      },
    },
  },

  '&.MuiAutocomplete-hasClearIcon': {
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      borderColor: '#3448FF',
      '&:hover': {
        borderColor: '#3448FF',
      },
    },
  },

  '& .MuiFormLabel-root.MuiInputLabel-root': {
    color: '#7174AC',
    fontSize: '14px',
    lineHeight: '20px',
    top: '-5px',
    zIndex: 99,
    '&.MuiFormLabel-filled': {
      display: 'none',
    },
  },

  '&.Mui-expanded': {
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      borderRadius: '16px 16px 0 0',
      '& .MuiOutlinedInput-notchedOutline': {
        padding: 0,
      },
    },
    '& .MuiFormLabel-root.MuiInputLabel-root': {
      display: 'none',
    },
  },

  '&.Mui-focused': {
    '& .MuiFormLabel-root.MuiInputLabel-root': {
      display: 'none',
    },
  },

  '& + .MuiAutocomplete-popper': {
    '& .MuiPaper-root.MuiAutocomplete-paper': {
      borderRadius: '0 0 16px 16px',
      border: '1px solid #E4E4EF',
      borderTop: 'none',
      boxShadow: '0px 5px 10px -8px #A0A1AA66',
      '& .MuiAutocomplete-noOptions': {
        padding: '8px 16px',
        color: '#212346',
        fontSize: '12px',
        lineHeight: '20px',
      },
      '& .MuiAutocomplete-listbox': {
        padding: '0',
        '& li': {
          padding: '8px 10px',
          whiteSpace: 'normal',
          fontSize: '12px',
          lineHeight: '20px',
          color: '#212346',
          '& .MuiButtonBase-root.MuiCheckbox-root': {
            padding: '2px',
            marginRight: '10px',
          },
          '&.Mui-focused': {
            backgroundColor: 'transparent',
          },
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
          '&.Mui-selected': {
            backgroundColor: '#DCDFF4',
          },
        },
        '&::-webkit-scrollbar': {
          width: '2px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#7174AC',
          borderRadius: '5px',
        },
      },
    },
  },
}));
// Original class: autocompletePopper
const StyledAutocompletePopper = styled(Popper)(({ theme }) => ({
  zIndex: 9000,

  '& .MuiPaper-root.MuiAutocomplete-paper': {
    borderRadius: '0 0 16px 16px',
    border: '1px solid #E4E4EF',
    borderTop: 'none',
    boxShadow: '0px 5px 10px -8px #A0A1AA66',
    '& .MuiAutocomplete-noOptions': {
      padding: '8px 16px',
      color: '#212346',
      fontSize: '12px',
      lineHeight: '20px',
    },
    '& .MuiAutocomplete-listbox': {
      padding: '0',
      '& li': {
        padding: '8px 10px',
        whiteSpace: 'normal',
        fontSize: '12px',
        lineHeight: '20px',
        color: '#212346',
        '& .MuiButtonBase-root.MuiCheckbox-root': {
          padding: '2px',
          marginRight: '10px',
        },
        '&.Mui-focused': {
          backgroundColor: 'transparent',
        },
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        '&.Mui-selected': {
          backgroundColor: '#DCDFF4',
        },
      },
      '&::-webkit-scrollbar': {
        width: '2px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#7174AC',
        borderRadius: '5px',
      },
    },
  },
}));
const Competencies = ({ componentMode, userId }) => {
  const apiRef = useTreeViewApiRef();
  const tooltipPos = React.useRef({ x: 0, y: 0 });
  const [hover, setHover] = React.useState(-1);
  const [position, setPosition] = React.useState({ x: 0, y: 0 });
  const [competencyRatings, setCompetencyRatings] = useState([]);
  const [showCompetenciesWarning, setShowCompetenciesWarning] = useState(false);
  const getLocalString = useTranslation();
  const [departments, setDepartments] = useState([]);
  const [grades, setGrades] = useState([]);
  const [departmentsList, setDepartmentsList] = useState([]);
  const [competencies, setCompetencies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [defaultExpandedItems, setDefaultExpandedItems] = useState([]);
  const [error, setError] = useState(null);
  const params = useParams();
  const handleClose = (event, reason) => {
    if (reason === 'select-option') {
      return;
    }
  };
  const isItemDisabled = item => !!item.disabled;
  const getAllItemIds = useCallback(items => {
    const ids = [];
    const collectIds = nodes => {
      nodes.forEach(node => {
        ids.push(node.id);
        if (node.children) {
          collectIds(node.children);
        }
      });
    };
    collectIds(items);
    return ids;
  }, []);
  const allItemIds = useMemo(() => {
    if (!competencies || competencies.length === 0) {
      return [];
    }
    return getAllItemIds(competencies);
  }, [competencies, getAllItemIds]);
  const getCurrentRating = (competencyId, competencies, grades = []) => {
    if (!Array.isArray(grades)) {
      console.error('Invalid grades format:', grades);
      return 0;
    }

    const item = findNodeById(competencies, competencyId);
    if (!item || item.type !== 'competency') {
      return 0;
    }
    const gradeId =
      item.gradeId ||
      item.services?.gradeId ||
      item.originalData?.services?.gradeId ||
      item.originalData?.columns?.find(c => c.fieldId === 'competencies.gradeId')?.valueId;

    if (!gradeId) {
      return 0;
    }

    try {
      const gradeIndex = grades.findIndex(g => g?.valueId === Number(gradeId));
      return gradeIndex >= 0 ? gradeIndex + 1 : 0;
    } catch (e) {
      console.error('Rating calculation error:', e);
      return 0;
    }
  };
  const getCategoryIds = useCallback(items => {
    const ids = [];
    const collectIds = nodes => {
      nodes.forEach(node => {
        if (node.type === 'category') {
          ids.push(node.id);
          if (node.children) {
            collectIds(node.children);
          }
        }
      });
    };
    collectIds(items);
    return ids;
  }, []);
  useEffect(() => {
    if (competencies?.length) {
      const categoryIds = getCategoryIds(competencies);
      setDefaultExpandedItems(categoryIds);
    }
  }, [competencies, getCategoryIds]);

  const updateCompetencyRating = async (competencyId, newValue) => {
    let selectedGrade = null;
    if (typeof newValue === 'number' && newValue > 0) {
      if (!grades?.length) {
        return;
      }
      const mapped = grades[newValue - 1]?.valueId;
      if (!mapped) {
        return;
      }
      selectedGrade = mapped;
    }

    const userIdUse = userId || params.id;
    try {
      const response = await addCompetenceRateByUser(userIdUse, {
        gradeId: selectedGrade,
        competencyId: Number(competencyId),
      });
      if (response) {
        const responseGradeId = response.data && response.data !== '' ? response.data.gradeId : null;
        setCompetencies(prev => {
          const updateGrade = nodes =>
            nodes.map(node => {
              if (node.originalId === competencyId && node.type === 'competency') {
                const updatedNode = { ...node };
                if (responseGradeId) {
                  updatedNode.gradeId = responseGradeId;
                  updatedNode.services = { ...updatedNode.services, gradeId: responseGradeId };
                  updatedNode.originalData = {
                    ...updatedNode.originalData,
                    services: { ...updatedNode.originalData?.services, gradeId: responseGradeId },
                    columns: (updatedNode.originalData?.columns || []).map(col =>
                      col.fieldId === 'competencies.gradeId' ? { ...col, valueId: responseGradeId } : col,
                    ),
                  };
                } else {
                  if ('gradeId' in updatedNode) {
                    delete updatedNode.gradeId;
                  }
                  if (updatedNode.services?.gradeId) {
                    const { gradeId, ...restServices } = updatedNode.services;
                    updatedNode.services = restServices;
                  }
                  const originalDataServices = updatedNode.originalData?.services || {};
                  if (originalDataServices?.gradeId) {
                    const { gradeId, ...rest } = originalDataServices;
                    updatedNode.originalData = {
                      ...updatedNode.originalData,
                      services: rest,
                    };
                  }
                  updatedNode.originalData = {
                    ...updatedNode.originalData,
                    columns: (updatedNode.originalData?.columns || []).map(col =>
                      col.fieldId === 'competencies.gradeId' ? { ...col, valueId: undefined } : col,
                    ),
                  };
                }
                return updatedNode;
              }
              return node.children ? { ...node, children: updateGrade(node.children) } : node;
            });
          return updateGrade(prev);
        });
      }
    } catch (err) {
      console.error('Failed to save rating:', err);
    }
  };
  const handleModalAction = useCallback(async e => {
    switch (e.currentTarget.attributes.value.value) {
      case 'cancel':
        setShowCompetenciesWarning(false);
        break;
    }
  }, []);
  const findNodeById = useCallback((nodes, id) => {
    for (const node of nodes) {
      if (node.id === id) {
        return node;
      }
      if (node.children) {
        const found = findNodeById(node.children, id);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }, []);

  const canDropItem = useCallback(
    ({ itemId, newPosition }) => {
      const draggedItem = findNodeById(competencies, itemId);
      const targetParent = newPosition.parentId ? findNodeById(competencies, newPosition.parentId) : null;

      if (!draggedItem) {
        return false;
      }
      if (itemId === newPosition.parentId) {
        return false;
      }
      if (draggedItem.type === 'competency' && !newPosition.parentId) {
        return false;
      }

      if (!targetParent) {
        return draggedItem.type === 'category';
      }

      if (draggedItem.type === 'category') {
        return targetParent.type === 'category';
      }

      if (draggedItem.type === 'competency') {
        return targetParent.type === 'category';
      }

      return false;
    },
    [findNodeById, competencies],
  );

  const handleItemMove = useCallback(
    async params => {
      try {
        const { itemId, newPosition } = params;
        if (!canDropItem(params)) {
          return;
        }
        setIsLoading(true);
        setCompetencies(prev => {
          const newTree = JSON.parse(JSON.stringify(prev));
          const draggedItem = findNodeById(newTree, itemId);
          if (!draggedItem) {
            return prev;
          }
          const removeNode = (nodes, id) => {
            const index = nodes.findIndex(node => node.id === id);
            if (index !== -1) {
              return nodes.splice(index, 1)[0];
            }
            for (const node of nodes) {
              if (node.children) {
                const removed = removeNode(node.children, id);
                if (removed) {
                  return removed;
                }
              }
            }
            return null;
          };

          const removedItem = removeNode(newTree, itemId);
          if (!removedItem) {
            return prev;
          }
          let topId = null;
          if (newPosition.index > 0) {
            const siblings = newPosition.parentId ? findNodeById(newTree, newPosition.parentId)?.children : newTree;
            if (siblings && siblings.length >= newPosition.index) {
              topId = siblings[newPosition.index - 1]?.originalId || null;
            }
          }
          const parentId = newPosition.parentId ? findNodeById(newTree, newPosition.parentId)?.originalId : null;
          const moveData = {
            topId: topId,
          };
          if (newPosition.parentId) {
            const parent = findNodeById(newTree, newPosition.parentId);
            if (parent) {
              parent.children = parent.children || [];
              parent.children.splice(newPosition.index, 0, removedItem);
            }
          } else {
            newTree.splice(newPosition.index, 0, removedItem);
          }
          parentId && (moveData.parentId = Number(parentId));
          moveData.topId = Number(moveData.topId);
          setTimeout(async () => {
            try {
              if (draggedItem.type === 'competency') {
                await moveCompetence(draggedItem.originalId, moveData);
              } else if (draggedItem.type === 'category') {
                delete moveData.category;
                await moveMatrixCategory(draggedItem.originalId, moveData);
              }
            } catch (err) {
              console.error('API move error:', err);
            }
          }, 0);

          return newTree;
        });
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    },
    [canDropItem, findNodeById],
  );
  const addNewCategory = useCallback(async () => {
    try {
      const newCategory = {
        name: getLocalString('Departments', 'labels', 'newCategory'),
      };
      const response = await addMatrixCategory(newCategory);
      const newFromServerCategory = {
        id: 'category_' + response.data.id,
        originalId: '' + response.data.id,
        label: response.data.name,
        disabled: response.data.isBlocked,
        parentId: response.data.parentId,
        type: 'category',
        children: [],
      };
      setCompetencies(prev => [...prev, newFromServerCategory]);
    } catch (error) {
      console.error('Error adding category:', error);
    }
  }, [getLocalString]);
  const addNewCompetence = useCallback(
    async id => {
      try {
        const newCompetence = {
          name: getLocalString('Departments', 'labels', 'newCompetence'),
          categoryId: Number(id),
        };
        const response = await addCompetence(newCompetence);
        const newFromServerCompetence = {
          id: `competency_${response.data.id}`,
          originalId: response.data.id,
          label: response.data.name,
          disabled: response.data.isBlocked,
          parentId: response.data.parentId,
          type: 'competency',
          children: [],
        };

        setCompetencies(prev => {
          const addCompetenceToCategory = nodes => {
            return nodes.map(node => {
              if (node.originalId === id.toString()) {
                return {
                  ...node,
                  children: [...node.children, newFromServerCompetence],
                };
              }
              if (node.children) {
                return {
                  ...node,
                  children: addCompetenceToCategory(node.children),
                };
              }
              return node;
            });
          };
          return addCompetenceToCategory(prev);
        });
      } catch (error) {
        console.error('Error adding competence:', error);
      }
    },
    [getLocalString],
  );
  const deleteFunction = useCallback(
    async (itemId, type) => {
      try {
        const response = type === 'category' ? await deleteMatrixCategory(itemId) : await deleteCompetence(itemId);
        if (response.status === 200) {
          setCompetencies(prev => {
            const removeNode = nodes => {
              return nodes
                .filter(node => node.originalId != itemId)
                .map(node => (node.children ? { ...node, children: removeNode(node.children) } : node));
            };
            return removeNode(prev);
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 420) {
          setError(getLocalString('Departments', 'errors', error.response.data.errorCode));
          setShowCompetenciesWarning(true);
        }
      }
    },
    [getLocalString],
  );
  const lockUnlock = useCallback(
    async (itemId, type) => {
      try {
        const response = type === 'category' ? await blockMatrixCategory(itemId) : await blockCompetence(itemId);
        if (response.data?.status === 'ok') {
          setCompetencies(prev => {
            const toggleDisabled = nodes => {
              return nodes.map(node => {
                if (node.originalId === itemId.toString()) {
                  return { ...node, disabled: !node.disabled };
                }
                if (node.children) {
                  return { ...node, children: toggleDisabled(node.children) };
                }
                return node;
              });
            };
            return toggleDisabled(prev);
          });
        }
      } catch (error) {
        if (error.response.status === 420) {
          setError(getLocalString('Departments', 'errors', error.response.data.errorCode));
          setShowCompetenciesWarning(true);
        }
      }
    },
    [getLocalString],
  );
  const handleLabelChange = useCallback(
    async (itemId, newLabel) => {
      if (!newLabel || newLabel.trim() === '') {
        return;
      }
      try {
        const item = findNodeById(competencies, itemId);
        if (item.type === 'category') {
          const response = await updateMatrixCategory(item.originalId, { name: newLabel });
          setCompetencies(prev => {
            const renameNode = nodes => {
              return nodes.map(node => {
                if (node.originalId === item.originalId.toString()) {
                  return {
                    ...node,
                    label: newLabel,
                    originalData: {
                      ...node.originalData,
                      rowName: newLabel,
                      columns: node.originalData?.columns?.map(col =>
                        col.fieldId === 'competencies.name' ? { ...col, valueId: newLabel, value: newLabel } : col,
                      ),
                    },
                  };
                }
                if (node.children && node.children.length > 0) {
                  return { ...node, children: renameNode(node.children) };
                }
                return node;
              });
            };
            return renameNode(prev);
          });
          if (!response.data) {
            throw new Error('Failed to update Category');
          }
        } else if (item.type === 'competency') {
          const response = await updateCompetence(item.originalId, { name: newLabel });
          setCompetencies(prev => {
            const renameNode = nodes => {
              return nodes.map(node => {
                if (node.originalId === item.originalId.toString()) {
                  return {
                    ...node,
                    label: newLabel,
                    originalData: {
                      ...node.originalData,
                      rowName: newLabel,
                      columns: node.originalData?.columns?.map(col =>
                        col.fieldId === 'competencies.name' ? { ...col, valueId: newLabel, value: newLabel } : col,
                      ),
                    },
                  };
                }
                if (node.children && node.children.length > 0) {
                  return { ...node, children: renameNode(node.children) };
                }
                return node;
              });
            };
            return renameNode(prev);
          });
          if (!response.data) {
            throw new Error('Failed to update Competency');
          }
        }
      } catch (err) {
        console.error('Error updating Category:', err);
        return false;
      }
    },
    [competencies, findNodeById],
  );
  const handleFormField = useCallback(
    async (newValue, itemId) => {
      try {
        const item = findNodeById(competencies, itemId);

        if (!item || item.type !== 'competency') {
          return;
        }
        const selectedDepartments = Array.isArray(newValue) ? newValue : [newValue];
        const departmentIds = selectedDepartments.map(d => d.valueId);
        setCompetencies(prev => {
          const updateNode = nodes => {
            return nodes.map(node => {
              if (node.id === itemId) {
                return {
                  ...node,
                  departments: selectedDepartments,
                };
              }
              if (node.children) {
                return {
                  ...node,
                  children: updateNode(node.children),
                };
              }
              return node;
            });
          };
          return updateNode([...prev]);
        });
        const response = await updateCompetence(item.originalId, {
          departmentIds: departmentIds,
        });

        if (!response.data) {
          throw new Error('Failed to update Competency');
        }
        // await ChangeDepartment(item.originalId, newValue.valueId);
      } catch (error) {
        console.error('Error updating department:', error);
        //setError('Failed to update department');
        // setShowCompetenciesWarning(true);
      }
    },
    [competencies, findNodeById],
  );
  const CustomTreeItem = React.forwardRef(function CustomTreeItem(props, ref) {
    const {
      id,
      itemId,
      label,
      disabled,
      departments,
      children,
      type,
      gradeId,
      originalData,
      handleFormField,
      originalId,
      ...other
    } = props;
    const {
      getContextProviderProps,
      getRootProps,
      getContentProps,
      getIconContainerProps,
      getCheckboxProps,
      getLabelProps,
      getLabelInputProps,
      getGroupTransitionProps,
      getDragAndDropOverlayProps,
      status,
      actions,
    } = useTreeItem({ id, itemId, departments, children, originalId, label, disabled, rootRef: ref });

    const { draggable, onDragStart, onDragOver, onDragEnd, ...otherRootProps } = getRootProps(other);
    const [dragPosition, setDragPosition] = useState({ x: 0, y: 0, show: false, text: '' });
    const ratingValue = type === 'competency' ? getCurrentRating(itemId, competencies, grades) : 0;
    const handleDrag = useCallback(e => {
      setDragPosition({
        x: e.clientX,
        y: e.clientY,
        show: true,
        text: e.currentTarget.dataset.position === 'insert' ? 'MOVE' : 'INSERT',
      });
    }, []);
    const handleAutocompleteClose = (event, reason) => {
      if (reason === 'select-option') {
        return;
      }
    };
    const handleDragEnd = useCallback(() => {
      setDragPosition(prev => ({ ...prev, show: false }));
    }, []);
    const [hover, setHover] = useState(-1);
    return (
      <TreeItemProvider
        sx={{
          borderBottom: 0,
          '& .MuiTreeItem-content[data-disabled]': {
            backgroundColor: 'red',
            color: 'red',
          },
          '&:hover .add-competence-btn': {
            display: 'flex',
          },
        }}
        {...getContextProviderProps()}
      >
        <TreeItemRoot
          sx={{
            borderBottom: 0,
          }}
          {...getRootProps(other)}
        >
          <TreeItemContent
            sx={{
              [`&[data-focused], &[data-selected]`]: {
                outline: '2px solid #3448FF !important',
              },
              '&[data-position="nest"]': {
                outline: '2px solid #3448FF !important',
              },
              padding: 0,
              opacity: '1 !important',
              borderBottom: '1px solid #E4E4EF',
              '&:hover .add-competence-btn': {
                display: 'flex',
              },
            }}
            {...getContentProps({
              onMouseDown: e => {
                if (e.target.closest('.MuiAutocomplete-root')) {
                  return;
                }
                getContentProps().onMouseDown?.(e);
              },
            })}
          >
            {componentMode === 'edit' && (
              <>
                <TreeItemIconContainer
                  sx={{
                    width: '32px',
                    height: '100%',
                    padding: '12px 8px',
                    position: 'relative',
                    borderRight: '1px solid #E4E4EF',
                  }}
                >
                  <ReorderIcon
                    sx={{
                      width: '17px',
                    }}
                    viewBox="0 0 16 16"
                  />
                </TreeItemIconContainer>
                <TreeItemIconContainer
                  sx={{
                    width: '32px',
                    height: '100%',
                    padding: '10px 8px',
                    position: 'relative',
                    borderRight: '1px solid #E4E4EF',
                  }}
                >
                  <DeleteColoredIcon
                    onClick={() => deleteFunction(originalId, type)}
                    sx={{
                      width: '24px',
                      height: '24px',
                      position: 'relative',
                      top: '4px',
                      left: '2px',
                    }}
                  />
                </TreeItemIconContainer>
                <TreeItemIconContainer
                  sx={{
                    width: '32px',
                    height: '100%',
                    padding: '12px 8px',
                    position: 'relative',
                    borderRight: '1px solid #E4E4EF',
                  }}
                >
                  <BlockColoredIcon
                    sx={{
                      width: '23px',
                      height: '16px',
                      color: '#656985',
                    }}
                    viewBox="0 0 16 16"
                    onClick={() => lockUnlock(originalId, type)}
                    color={status.disabled ? '#656985' : '#DCDFF4'}
                  />
                </TreeItemIconContainer>
              </>
            )}
            <TreeItemIconContainer
              sx={[
                {
                  width: 'auto',
                  paddingLeft: 'calc(30px * var(--TreeView-itemDepth, 1))',
                  marginLeft: '15px',
                },
                type === 'competency' && {
                  width: '50%',
                  borderRight: '1px solid #E4E4EF',
                  justifyContent: 'left',
                },
              ]}
            >
              {type === 'category' && (
                <FolderIcon
                  sx={{
                    width: '20px',
                  }}
                  viewBox="0 0 20 20"
                />
              )}
              {status.editing && componentMode === 'edit' ? (
                <TreeItemLabelInput
                  sx={{
                    width: 'auto',
                    fontSize: '14px',
                    padding: '10px',
                    opacity: status.disabled ? 0.38 : 1,
                  }}
                  {...getLabelInputProps()}
                />
              ) : (
                <TreeItemLabel
                  sx={{
                    width: 'auto',
                    fontSize: '14px',
                    padding: '10px',
                    opacity: status.disabled ? 0.38 : 1,
                  }}
                  {...getLabelProps()}
                />
              )}
            </TreeItemIconContainer>
            <TreeItemIconContainer {...getIconContainerProps()}>
              <TreeItemIcon status={status} />
            </TreeItemIconContainer>
            {type === 'category' && componentMode === 'edit' && (
              <Box
                className="add-competence-btn"
                sx={{
                  borderRadius: '16px',
                  padding: '0',
                  color: '#7E8BE5',
                  fontSize: '12px',
                  backgroundColor: '#E5E9FF',
                  display: 'none',
                  transition: 'opacity 0.5s ease',
                }}
              >
                <IconButton
                  onClick={() => addNewCompetence(originalId)}
                  sx={{
                    padding: '5px 8px',
                    color: '#7E8BE5',
                    fontSize: '12px',
                  }}
                >
                  <AddColorPlusIcon
                    sx={{
                      width: '12px',
                      marginRight: '8px',
                    }}
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                  />
                  <Box>{getLocalString('Departments', 'labels', 'newCompetence')}</Box>
                </IconButton>
              </Box>
            )}
            {type === 'competency' && componentMode === 'edit' && (
              <>
                <StyledFieldAutocomplete
                  multiple
                  disableCloseOnSelect
                  disableClearable
                  noOptionsText={getLocalString('labels', 'notFound')}
                  onChange={(event, newValue) => handleFormField(newValue, itemId)}
                  options={departmentsList || []}
                  sx={{
                    width: '100%',
                    border: 'none',
                    '& .MuiChip-root': {
                      display: 'none',
                    },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props} key={option.valueId}>
                      <Checkbox
                        icon={<CheckboxIcon width="12" height="12" viewBox="0 0 12 12" />}
                        checkedIcon={<CheckboxIconChecked width="12" height="12" viewBox="0 0 12 12" />}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.valueName}
                    </MenuItem>
                  )}
                  value={departmentsList.filter(
                    d =>
                      departments?.some(dept => dept.valueId === d.valueId) ||
                      originalData?.services?.departmentIds?.includes(d.valueId),
                  )}
                  isOptionEqualToValue={(option, value) => option.valueId === value?.valueId}
                  getOptionLabel={option => option?.valueName || ''}
                  renderInput={params => {
                    const selectedDepartments = departmentsList.filter(
                      d =>
                        departments?.some(dept => dept.valueId === d.valueId) ||
                        originalData?.services?.departmentIds?.includes(d.valueId),
                    );
                    const displayValue = selectedDepartments.map(d => d.valueName).join(', ');

                    return (
                      <TextField
                        {...params}
                        value={displayValue}
                        placeholder={displayValue || getLocalString('labels', 'select')}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            padding: 0,
                            border: 'none',
                            '& fieldset': {
                              border: 'none',
                            },
                            '&:hover fieldset': {
                              border: 'none',
                            },
                            '&.Mui-focused fieldset': {
                              border: 'none',
                            },
                          },
                        }}
                        onClick={e => {
                          e.stopPropagation();
                          params.InputProps.onClick?.(e);
                        }}
                        onClose={(event, reason) => {
                          if (reason === 'toggleInput' || reason === 'escape') {
                            return;
                          }
                        }}
                        openOnFocus
                        disablePortal
                      />
                    );
                  }}
                  popupIcon={<ChevronIcon direction="down" viewBox="0 0 24 24" />}
                  slots={{
                    popper: props => (
                      <StyledAutocompletePopper
                        {...props}
                        onClick={e => e.stopPropagation()}
                        placement="bottom-start"
                      ></StyledAutocompletePopper>
                    ),
                  }}
                />
              </>
            )}
            {type === 'competency' && componentMode === 'view' && (
              <Box sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <Rating
                  name={`rating-${itemId}`}
                  value={getCurrentRating(itemId, competencies, grades)}
                  precision={1}
                  sx={{
                    '&.MuiRating-root': {
                      gap: '15px',
                    },
                    '& .MuiRating-icon': {
                      width: '18px !important',
                      height: '18px !important',
                    },
                  }}
                  max={grades.length}
                  onChange={(event, newValue) => {
                    updateCompetencyRating(originalId, newValue);
                  }}
                  onChangeActive={(event, newHover) => {
                    setHover(newHover - 1);
                  }}
                />
                {hover !== -1 && grades[hover] && (
                  <Box
                    sx={{
                      ml: 2,
                      px: 1.5,
                      py: 0.5,
                      background: '#fff',
                      border: '1px solid #E4E4EF',
                      borderRadius: '6px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                      position: 'absolute',
                      left: '110%',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      whiteSpace: 'nowrap',
                      zIndex: 10,
                    }}
                  >
                    {grades[hover]?.valueName}
                  </Box>
                )}
              </Box>
            )}
            <StyledDragOverlay
              {...getDragAndDropOverlayProps()}
              onDragOver={handleDrag}
              onDragEnd={handleDragEnd}
              sx={{
                '&:not([data-focused], [data-selected]):hover': {
                  backgroundColor: 'blue',
                  color: 'blue',
                },
                '&.MuiTreeItemDragAndDropOverlay-root': {
                  '&[data-position="insert"]::before': {
                    backgroundColor: '#1976d2 !important',
                    height: '2px !important',
                  },
                  '&[data-position="nest"]': {
                    outline: '2px solid #4CAF50 !important',
                  },
                  '&:not([data-focused], [data-selected]):hover': {
                    backgroundColor: 'blue',
                    color: 'blue',
                  },
                },
              }}
            />
          </TreeItemContent>
          {children && <TreeItemGroupTransition {...getGroupTransitionProps()} />}
        </TreeItemRoot>
        {dragPosition.show && (
          <Box
            sx={{
              position: 'fixed',
              left: dragPosition.x + 10,
              top: dragPosition.y - 30,
              backgroundColor: 'white',
              padding: '4px 8px',
              borderRadius: 4,
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              fontSize: 12,
              fontWeight: 'bold',
              color: dragPosition.text === 'MOVE' ? '#1976d2' : '#ff4081',
              zIndex: 2000,
              pointerEvents: 'none',
            }}
          >
            {dragPosition.text}
          </Box>
        )}
      </TreeItemProvider>
    );
  });
  const transformToTree = useCallback(data => {
    if (!data || !Array.isArray(data)) {
      return [];
    }
    const nodesMap = {};
    const categoriesMap = {};
    const competenciesMap = {};

    data.forEach((item, index) => {
      const uniqueId = `${item.type}_${item.rowId}`;
      const node = {
        id: uniqueId,
        originalId: item.rowId,
        label: item.rowName,
        type: item.type,
        disabled: item.services.isBlocked,
        children: [],
        originalData: item,
      };

      if (item.type === 'competency') {
        const departmentFields = item.columns.filter(col => col.fieldId === 'competencies.departmentId');
        if (departmentFields.length > 0) {
          node.departments = departmentFields.map(dept => ({
            valueId: dept.valueId,
            valueName: dept.valueName,
          }));
        }
        let gradeId = null;
        if (item.services && item.services.gradeId) {
          gradeId = item.services.gradeId;
        } else {
          const gradeCol = item.columns.find(col => col.fieldId === 'competencies.gradeId');
          if (gradeCol) {
            gradeId = gradeCol.valueId || gradeCol.value;
          }
        }
        if (gradeId) {
          node.gradeId = gradeId;
        }
      }

      nodesMap[uniqueId] = node;

      if (item.type === 'category') {
        categoriesMap[uniqueId] = node;
      } else if (item.type === 'competency') {
        competenciesMap[uniqueId] = node;
      }
    });
    const tree = [];
    Object.values(categoriesMap).forEach(category => {
      const parentId = category.originalData.services.parentId;

      if (parentId === null) {
        tree.push(category);
      } else {
        const parentCategory = Object.values(categoriesMap).find(cat => cat.originalId === parentId.toString());
        if (parentCategory) {
          parentCategory.children.push(category);
        }
      }
    });

    Object.values(competenciesMap).forEach(competency => {
      const categoryId = competency.originalData.services.categoryId;

      if (categoryId) {
        const parentCategory = Object.values(categoriesMap).find(cat => cat.originalId === categoryId.toString());

        if (parentCategory) {
          parentCategory.children.push(competency);
        } else {
          tree.push(competency);
        }
      } else {
        tree.push(competency);
      }
    });
    Object.values(categoriesMap).forEach(category => {
      const services = category.originalData.services;
      const orderMap = {};
      if (services.children && Array.isArray(services.children)) {
        services.children.forEach((childId, index) => {
          const child = Object.values(categoriesMap).find(cat => cat.originalId === childId.toString());
          if (child) {
            orderMap[child.id] = index;
          }
        });
      }
      if (services.competency && Array.isArray(services.competency)) {
        services.competency.forEach((compId, index) => {
          const comp = Object.values(competenciesMap).find(c => c.originalId === compId.toString());
          if (comp) {
            orderMap[comp.id] = (services.children?.length || 0) + index;
          }
        });
      }
      if (Object.keys(orderMap).length > 0) {
        category.children.sort((a, b) => {
          const aOrder = orderMap[a.id] !== undefined ? orderMap[a.id] : Infinity;
          const bOrder = orderMap[b.id] !== undefined ? orderMap[b.id] : Infinity;
          return aOrder - bOrder;
        });
      }
    });

    return tree;
  }, []);
  const fetchCompetencies = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await getMatrixGategories();
      const transformedData = transformToTree(response.data.rows);
      setCompetencies(transformedData);
      return transformedData;
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [transformToTree]);
  const fetchDepartmentsList = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await getDepartmentsList();
      setDepartmentsList(response.data);
      return response.data;
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, []);
  const fetchCompetenciesByUser = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const userIdUse = userId || params.id;
      const response = await getCompetenceByUser(userIdUse);
      if (response.data?.rows) {
        setCompetencyRatings(response.data.rows);
      }
      const transformedData = transformToTree(response.data.rows);
      setCompetencies(transformedData);
      return transformedData;
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [transformToTree, params.id, userId]);
  const fetchGradesList = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await getGradesList();
      setGrades(Array.isArray(response?.data) ? response.data : []);
      return response.data;
    } catch (err) {
      setError(err);
      setGrades([]);
    } finally {
      setIsLoading(false);
    }
  }, []);
  const fetchGrades = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await getCompetencyGrades();
      return response.data;
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    const loadData = async () => {
      if (componentMode === 'view') {
        await fetchCompetenciesByUser();
        //await fetchCompetencies();
        await fetchGradesList();
        await fetchGrades();
      } else {
        await fetchCompetencies();
        await fetchDepartmentsList();
      }
    };
    loadData();
  }, [componentMode, fetchCompetencies, fetchGrades, fetchGradesList, fetchDepartmentsList, fetchCompetenciesByUser]);
  return (
    <>
      <WarningModal
        onlyCancel
        isWarningModalOpen={showCompetenciesWarning}
        handleToggle={handleModalAction}
        closeWarningModal={() => setShowCompetenciesWarning(false)}
        title={error}
      />
      <StyledDepartmentsContainer
        sx={{
          marginTop: '30px',
        }}
      >
        <RichTreeViewPro
          apiRef={apiRef}
          defaultExpandedItems={defaultExpandedItems}
          items={competencies}
          {...(componentMode === 'edit' ? { itemsReordering: true } : {})}
          isItemEditable
          canMoveItemToNewPosition={params => {
            return canDropItem(params);
          }}
          slots={{
            expandIcon: ArrowDownIcon,
            collapseIcon: ArrowUpIcon,
            item: props => <CustomTreeItem {...props} handleFormField={handleFormField} />,
          }}
          slotProps={{
            item: ownerState => {
              const findItem = (items, id) => {
                for (const item of items) {
                  if (item.id === id) {
                    return item;
                  }
                  if (item.children) {
                    const found = findItem(item.children, id);
                    if (found) {
                      return found;
                    }
                  }
                }
                return null;
              };
              const item = findItem(competencies, ownerState.itemId);
              const baseProps = {
                type: item?.type,
                departments: item?.departments || [],
                originalData: item?.originalData,
                originalId: item?.originalId,
              };
              if (item?.type === 'competency') {
                return { ...baseProps, gradeId: item.gradeId };
              }
              return baseProps;
            },
            dragAndDropOverlay: {
              sx: {
                '&[data-position="insert"]::before': {
                  backgroundColor: '#1976d2 !important',
                },
                '&:not([data-focused], [data-selected]):hover': {
                  backgroundColor: 'blue',
                  color: 'blue',
                },
                '&[data-position="nest"]': {
                  outline: '2px solid #4CAF50 !important',
                },
              },
            },
          }}
          isItemDisabled={isItemDisabled}
          onItemPositionChange={handleItemMove}
          onItemLabelChange={handleLabelChange}
        />
        {componentMode === 'edit' && (
          <Box
            sx={{
              padding: '8px 16px',
            }}
          >
            <IconButton onClick={addNewCategory} sx={{ padding: '0' }}>
              <PlusIcon width="24" height="24" viewBox="0 0 24 24" />
            </IconButton>
          </Box>
        )}
      </StyledDepartmentsContainer>
    </>
  );
};

export default Competencies;
